import { Pool } from "../../utils/Pool";
export class RestoreCmd {
    static create() {
        return Pool.getItemByClass("RestoreCmd", RestoreCmd);
    }
    recover() {
        Pool.recover("RestoreCmd", this);
    }
    run(context) {
        context.restore();
    }
    get cmdID() {
        return RestoreCmd.ID;
    }
}
RestoreCmd.ID = "Restore";
